const broadcastChannel = new BroadcastChannel('user-login');

export default broadcastChannel;
